module.exports = __webpack_public_path__ + "webpc/img/icon_share_1.7c424f9f.png";